<template>
  <v-app class="app-layout">
    <div class="ios-topbar-bg"></div>
    <portal-target name="app-bar">
      <v-app-bar
        app
        dark
        color="secondary"
      />
    </portal-target>
    <Child />
    <v-container
      v-if="updateAvailable"
      class="py-0"
    >
      <v-alert
        dismissible
        type="info"
      >
        <v-row
          align="center"
          no-gutters
        >
          <v-col class="grow">
            {{ $t('misc.update_available') }}
          </v-col>
          <v-col class="shrink">
            <v-btn
              small
              @click="reload"
            >
              {{ $t('misc.reload') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-alert>
    </v-container>
  </v-app>
</template>

<script>
import Child from '@/components/layout/Child';

export default {
  name: 'AppLayout',

  components: {
    Child
  },

  props: {
    updateAvailable: { type: Boolean, default: false }
  },

  methods: {
    reload () {
      window.location.reload();
    }
  }
};
</script>

<style lang="scss">
.ios-topbar-bg {
  height: env(safe-area-inset-top);
  width: 100%;
  background-color: #1e2e51;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10000;
}
.v-toolbar.v-app-bar,
header.v-sheet.theme--dark.v-toolbar {
  top: env(safe-area-inset-top) !important;
}
.app-layout {
  padding-top: env(safe-area-inset-top);
}
.v-application--wrap, .v-dialog__content {
  min-height: 100vh;
  min-height: calc(100vh - env(safe-area-inset-top));
}
</style>
